export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      title: 'LINE初步諮詢',
      description: '透過LINE了解您的需求與預算',
    },
    {
      number: '2',
      title: '現場勘查評估',
      description: '專業團隊到府丈量與評估',
    },
    {
      number: '3',
      title: '報價與方案討論',
      description: '提供透明報價與設計方案',
    },
    {
      number: '4',
      title: '簽約與工程排程',
      description: '確認合約內容與施工時程',
    },
    {
      number: '5',
      title: '施工與監工',
      description: '專業施工團隊與品質監控',
    },
    {
      number: '6',
      title: '竣工交屋',
      description: '完工驗收與售後服務',
    },
  ];

  return (
    <section id="process" className="py-24 bg-warm-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-primary mb-4 font-serif">
            透明流程，安心裝修
          </h2>
          <p className="text-base text-gray-600">六個步驟，讓您的家煥然一新</p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5">
            <div className="max-w-5xl mx-auto h-full border-t-2 border-dashed border-[#4A90C2]/40"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-4">
            {steps.map((step, index) => (
              <div key={index} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 mb-6">
                  <div className="w-20 h-20 rounded-full bg-primary flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                    {step.number}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-10 left-20 w-full">
                      <i className="ri-arrow-right-line text-2xl text-[#4A90C2]/60"></i>
                    </div>
                  )}
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow w-full">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}